import * as yup from 'yup';

export const CreateClubSchema = yup.object({
    name: yup.string().required('Errors.error_required').max(85, 'Errors.error_max_85'),
    category: yup.string().required('Errors.error_required'),
    description: yup.string().required('Errors.error_required').max(4000, 'Errors.error_max_4000'),
});
